interface StarburstProps {
  children: React.ReactNode;
  className?: string;
  size?: "sm" | "md" | "lg";
}

export default function Starburst({ children, className = "", size = "md" }: StarburstProps) {
  const sizeClasses = {
    sm: "w-16 h-16 text-xs",
    md: "w-24 h-24 text-sm",
    lg: "w-32 h-32 text-base",
  };

  return (
    <div className={`relative inline-flex items-center justify-center ${sizeClasses[size]} ${className}`}>
      <svg viewBox="0 0 100 100" className="absolute inset-0 w-full h-full fill-sun-yellow drop-shadow-lg">
        <polygon points="50,0 61,15 79,2 76,22 98,22 85,38 100,50 85,62 98,78 76,78 79,98 61,85 50,100 39,85 21,98 24,78 2,78 15,62 0,50 15,38 2,22 24,22 21,2 39,15" />
      </svg>
      <span className="relative z-10 font-heading font-black text-foreground text-center leading-tight">
        {children}
      </span>
    </div>
  );
}
